<template>
  <div>
    <v-card class="pl-5 pr-5">
      <div class="row pb-2">
        <button @click="closeHistory"><v-icon class="mr-2" @click="onEdit(item)"
          >mdi-arrow-left</v-icon
        ></button>
        <h1>{{ appName }} Version History</h1>
      </div>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="textSearch"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Version History
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="AppName"
                label="App Name"
                v-model="appName"
                :rules="appNameRules"
                required
                :disabled="true"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="deviceType"
                label="Device Type"
                v-model="selectedObj.deviceType"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
             <v-text-field
                id="Version"
                label="Version"
                :rules="appVersionRules"
                required
                v-model="selectedObj.version"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="AssemblyVersion"
                label="Assembly Version"
                v-model="selectedObj.assemblyVersion"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="Url"
                label="URL"
                v-model="selectedObj.Url"
              ></v-text-field>
            </div>
            <div class="col pt-8">
                <v-checkbox
                v-model="selectedObj.isMandatory"
                id="isMandatory"
                label="Is Mandatory"
              ></v-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-textarea
                id="ReleaseNotes"
                clearable
                clear-icon="mdi-close-circle"
                label="Release Notes *"
                value=""
                v-model="selectedObj.releaseNotes"
                counter
              ></v-textarea>
            </div>
          </div>
          
          <v-divider  class="pt-5"></v-divider>
          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
        <ConfirmationDialog ref="confirm" />
      </div>
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">App Name</th>
                  <th class="text-left">App version</th>
                  <th class="text-left">Device Type</th>
                  <th class="text-left">Release Date</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.appName }}</td>
                  <td>{{ item.version }}</td>
                  <td>
                    {{ item.deviceType }}
                  </td>
                    <td>{{ new Date(item.releaseDate).toLocaleDateString() }}</td>
                  <!---->
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <!-- <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    > -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import * as api from "@/api";
export default {
  name: "AppVersionsHistory",
  components: {
    Notification,
    Pagination,
    ConfirmationDialog,
  },
  computed: {
  },
  created() {
    this.getAppVersionsByPagin();
  },
  emits: ['close'],
  methods: {
    closeHistory() {
      this.$emit('close')
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getAppVersionsByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getAppVersionsByPagin();
    },
    getAppVersionsByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      if (!this.appName) {
        that.overlay = false
        return;
      }
      new Promise((resolve, reject) => {
        api
          .getByPagin(`app-version-history/${this.appName}`, this.paging)
          .then((response) => {
            that.overlay = false
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    onNew() {
      console.log(this.appName);
      this.isEdit = true;
      this.id = 0;
      this.appVersion = "";
      this.deviceType = "";
      this.releaseNotes = "";
      this.assemblyVersion = "";  
      this.Url = "";
      this.isMandatory = false;
      this.valid = false;
      this.selectedObj.id = 0;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid) {
        that.overlay = false
        return;
      }
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("app-version-history", this.selectedObj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              if (that.id == 0) {
                this.notify.message = "Record successfully created.";
              } else {
                this.notify.message = "Record successfully updated.";
              }
              this.appName = this.selectedObj.appName;
              this.selectedObj = {
                appName: this.appName,
                version: "",
                deviceType: "",
                assemblyVersion: "",
                isMandatory: false,
                Url: "",
                releaseNotes: "",
              };
              this.getAppVersionsByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
            that.overlay = false
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Entry Error");
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            }
            this.loading = false;
            that.overlay = false
          });
      });

      this.isEdit = false;
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("app-version-history", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getAppVersions();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.selectedObj = {
        appName: this.appName,
        version: "",
        deviceType: "",
        assemblyVersion: "",
        isMandatory: false,
        Url: "",
        releaseNotes: "",
      };
    },
    getAppVersions() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("app-version-history")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setAppName(appName) {
      this.appName = appName;
      this.selectedObj.appName = appName;
    },
  },
  watch: {
    appName(newVal, oldVal) {
      this.getAppVersionsByPagin();
    },
  },
  data() {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        appName: "",
        version: "",
        deviceType: "",
        assemblyVersion: "",
        isMandatory: false,
        Url: "",
        releaseNotes: "",
      },
      id: 0,
      appName: "",
      version: "",
      deviceType: "",
      assemblyVersion: "",
      isMandatory: false,
      Url: "",
      releaseNotes: "",
      appNameRules: [(v) => !!v || "App Name is required"],
      appVersionRules: [(v) => !!v || "App Version is required"],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      tab: null,
      overlay : false
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppVersionsHistory.vue